import { Component, ElementRef, OnInit } from "@angular/core";
import { CheckinCheckoutService } from "src/app/services/checkin-checkout.service";
import { ViewChild } from "@angular/core";
import { NgxScannerQrcodeComponent } from "ngx-scanner-qrcode";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { BehaviorSubject } from "rxjs";

interface ScannerQRCodeDevice {
  kind: string;
  label: string;
  groupId: string;
  deviceId: string;
}

@Component({
  selector: "app-scan-qr-code",
  templateUrl: "./scan-qr-code.component.html",
  styleUrls: ["./scan-qr-code.component.scss"],
})
export class ScanQrCodeComponent {
  scanTimeout: any;
  scanSuccessful: boolean = false;
  stopMultiRequst: any = 0;

  @ViewChild(NgxScannerQrcodeComponent, { static: false })
  scanner: NgxScannerQrcodeComponent;
  devices$ = new BehaviorSubject<ScannerQRCodeDevice[]>([]);
  selectedCamera: string;
  scannedData: any;
  qrdata: any;
  cameraIndex: number = 0; // To keep track of the selected camera

  constructor(
    private router: Router,
    private checkincheckoutservice: CheckinCheckoutService
  ) {}

  ngAfterViewInit() {
    this.startScanner();
  }

  startScanner() {
    if (this.scanner) {
      this.scanner.start();
      this.getAvailableDevices();
    }
  }

  getAvailableDevices() {
    this.scanner.devices.subscribe((devices) => {
      this.devices$.next(devices);
      this.openBackCameraIfAvailable();
    });
  }

  openBackCameraIfAvailable() {
    const devices = this.devices$.value;
    console.log("devices", devices);

    const rearCameraRegex = /back|trás|rear|traseira|environment|ambiente/gi;
    const device =
      devices.find((f) => rearCameraRegex.test(f.label)) || devices[0];

    if (device) {
      this.scanner.playDevice(device.deviceId);
      this.selectedCamera = device.label;
      this.cameraIndex = devices.indexOf(device);
    }
  }

  rotateCamera() {
    const devices = this.devices$.value;
    if (devices.length > 1) {
      this.cameraIndex = (this.cameraIndex + 1) % devices.length;
      const nextDevice = devices[this.cameraIndex];
      this.scanner.playDevice(nextDevice.deviceId);
      this.selectedCamera = nextDevice.label;
    }
  }

  handleScanResult(scannedData: any): void {
    if (this.stopMultiRequst > 0) {
      return;
    }

    if (this.isValidScannedData(scannedData)) {
      this.stopMultiRequst++;
      this.vibrateDevice();

      this.qrdata = scannedData.data.value[0].value;
      this.checkincheckoutservice.checkIn(this.qrdata).subscribe(
        (response) => {
          if (response.isSuccess) {
            Swal.fire({
              title: response.message,
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Okay",
            }).then((result) => {
              if (result.value) {
                window.location.reload();
              }
            });

            this.navigateToDashboard();
          } else {
            console.error("Check-in failed: " + response.message);
          }
        },
        (error) => {
          console.error("API call error: " + error);
        }
      );
    }
  }

  isValidScannedData(scannedData: string): boolean {
    return true;
  }

  navigateToDashboard(): void {
    this.router.navigate(["/time-dashboard"]);
  }

  vibrateDevice() {
    if ("vibrate" in navigator) {
      navigator.vibrate([200]);
    }
  }
}
